import { useScrollBarStore } from '@stores/useScrollBarStore'

export function useScrollBar() {
  const { scrollTo } = useScrollBarStore()

  return {
    scrollTo,
  }
}
